<template>
    <div id="packages-container" class="generic-wrapper">
        <h1 class="page-title">Paquetes</h1>
        <p class="body-text">Ofrecemos los mejores paquetes para que tú y tus seres queridos
            puedan pasar las mejores vacaciones en la ciudad de La Ceiba. Entre nuestros paquetes
            puedes encontrar un viaje a cayos cochinos, una visita a la cuenca del Río Cangrejal,
            o un paquete romántico para ti y tú pareja. Independientemente del paquete
            que escojas estamos seguros que pasarás un excelente tiempo con nosotros.
        </p>
        <PackageView v-for="p in packages" :name="p.name" :key="p.id"
                     :starting-price="p.startingPrice" :id="p.id"
                     :short-description="p.shortDescription" :images="p.images"
                     :includes="p.includes"/>
    </div>
</template>

<script>
    import PackageView from "../components/PackageView";

    export default {
        name: "Packages",
        components: {
            PackageView,
        },
        data() {
            return {
                packages: [
                    {
                        name: "Rafting",
                        startingPrice: 75,
                        id: 1,
                        shortDescription: "Disfrute el recorrido bajando los turbulentos " +
                            "y emocionantes rápidos de Clase III y IV del Río. " +
                            "El Parque Nacional Pico Bonito limita por la margen " +
                            "izquierda del Río y podremos apreciar su magnífica " +
                            "vegetación y paisajes durante todo el viaje. ",
                        includes: [
                            'Hospedaje según acomodación',
                            'Desayunos',
                            'Balsas inflables',
                            'chalecos salva vidas',
                            'cascos protectores',
                            'remos',
                            'equipo de rescate',
                            'kit de primeros auxilios',
                            'Guías profesionales bilingües',
                            'Fruta y Te helado',
                            'Almuerzo'
                        ],
                        images: [
                            {
                                src: require('../assets/images/packages/rafting-1.jpeg'),
                                thumbnail: require('../assets/images/packages/scaled/rafting-1.jpeg'),
                                w: 720,
                                h: 1280,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/packages/rafting-2.jpg'),
                                thumbnail: require('../assets/images/packages/scaled/rafting-2.jpg'),
                                w: 2048,
                                h: 1365,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/packages/rafting-3.jpeg'),
                                thumbnail: require('../assets/images/packages/scaled/rafting-3.jpeg'),
                                w: 1280,
                                h: 849,
                                alt: 'Some Unsplash image'
                            },
                        ]
                    },
                    {
                        name: "Cayos Cochinos",
                        startingPrice: 95,
                        id: 2,
                        shortDescription: "Los Cayos Cochinos pertenecen a la segunda barrera " +
                            "coralina más grande del mundo, Las actividades que podemos " +
                            "disfrutar en los Cayos Cochinos son las siguientes; nadar " +
                            "en aguas azul turquesa, relajarse en las playas de arena " +
                            "blanca, hacer snorkeling y realizar caminatas en " +
                            "busca de la boa rosada. ",
                        includes: [
                            'Hospedaje según acomodación',
                            'Desayunos',
                            'Traslado en lancha',
                            'Chaleco salva vida',
                            'Entrada al área protegida',
                            'Visita al centro de información y estación científica',
                            'Guía interpretativo',
                            'Equipo y herramientas para realizar snorkeling',
                            'Breve recorrido en busca de la boa rosada',
                            'Almuerzo con bebida incluida',
                            'Impuestos'

                        ],
                        images: [
                            {
                                src: require('../assets/images/packages/snorkeling2.jpeg'),
                                thumbnail: require('../assets/images/packages/scaled/snorkeling2.jpeg'),
                                w: 1281,
                                h: 851,
                                alt: 'Some Unsplash image'
                            },
                            {
                                src: require('../assets/images/packages/snorkeling-arrecife.jpeg'),
                                thumbnail: require('../assets/images/packages/scaled/snorkeling-arrecife.jpeg'),
                                w: 1280,
                                h: 851,
                                alt: 'Some Unsplash image'
                            }
                        ]
                    },
                    // {
                    //     name: "Románticos",
                    //     startingPrice: 90,
                    //     id: 3,
                    //     shortDescription: "En Las Hamacas adoramos a las personas detallistas, " +
                    //         "no de comprar regalos, sino de regalar momentos " +
                    //         "únicos e incomparables, por eso te ayudamos a crearlos. " +
                    //         "Disfruta de una velada romántica junto a tu pareja con " +
                    //         "este increíble paquete. ",
                    //     images: [
                    //         {
                    //             src: require('../assets/images/packages/snorkeling2.jpeg'),
                    //             thumbnail: 'http://via.placeholder.com/80x80',
                    //             w: 1200,
                    //             h: 900,
                    //             alt: 'Some Unsplash image'
                    //         },
                    //         {
                    //             src: require('../assets/images/packages/snorkeling-arrecife.jpeg'),
                    //             thumbnail: 'http://via.placeholder.com/80x80',
                    //             w: 1200,
                    //             h: 900,
                    //             alt: 'Some Unsplash image'
                    //         },
                    //         {
                    //             src: require('../assets/images/packages/rio-zacate.jpg'),
                    //             thumbnail: 'http://via.placeholder.com/80x80',
                    //             w: 1200,
                    //             h: 900,
                    //             alt: 'Some Unsplash image'
                    //         },
                    //     ]
                    // }
                ]
            }
        }
    }
</script>

<style scoped>
    .body-text {
        margin-bottom: 30px;
    }
</style>